import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SideNavLayout from "../Sidenav/SideNavLayout";
import AddTypeModal from "./addtype";
import api from "../api/api";
import { Backdrop, CircularProgress } from "@mui/material";
import ToastMessage from "../utils/muitoast";
import DeleteConfirmModal from "./deletemodal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const ManualWrapper = () => {
  const [types, setTypes] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [newType, setNewType] = useState("");
  const [loader, setLoader] = useState(false);
const [deleteModal, setDeleteModal] = useState(false);
const [selectedFolder, setSelectedFolder] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const showToast = (msg, type = "success") => {
    setAlertMessage(msg);
    setSeverity(type);
    setOpen(true);
  };

  const handleCloseToast = () => setOpen(false);

  // =====================================================
  // 🔹 FETCH ALL FOLDERS
  // =====================================================
  const fetchTypes = async () => {
    try {
      setLoader(true);

      const res = await api.get("/v1/documents/manual/folder/get-all");

   if(res.status==200){
 setTypes(res.data || []);
   }else{
setTypes([]);
   }

      // store full object (id + folder_type)
     
    } catch (err) {
      showToast("Failed to load folders", "error");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchTypes();
  }, []);
const openDeleteModal = (folder, e) => {
  e.stopPropagation(); // prevent card click navigation
  setSelectedFolder(folder);
  setDeleteModal(true);
};
const confirmDelete = async () => {
  if (!selectedFolder) return;

  try {
    setLoader(true);

    const res = await api.delete(
      `/v1/documents/manual/folder/delete/${selectedFolder.id}`
    );

    // ✅ SUCCESS RESPONSE
    if (res.status === 200) {
      showToast(res.data?.message || "Folder deleted successfully", "success");

      // close modal
      setDeleteModal(false);
      setSelectedFolder(null);

      // 🔄 refresh data from server
      await fetchTypes();
    } else {
      showToast("Delete failed", "error");
    }
  } catch (err) {
    showToast(
      err?.response?.data?.message || "Something went wrong",
      "error"
    );
  } finally {
    setLoader(false);
  }
};

  // =====================================================
  // 🔹 CREATE FOLDER
  // =====================================================
  const handleAddType = async () => {
    if (!newType.trim()) {
      showToast("Folder name required", "warning");
      return;
    }

    // prevent duplicate
    const exists = types.some(
      (t) => t.folder_type.toLowerCase() === newType.toLowerCase()
    );

    if (exists) {
      showToast("Folder already exists", "warning");
      return;
    }

    try {
      setLoader(true);

      await api.post(
        `/v1/documents/manual/folder/create?folder_type=${newType}`,
        {}
      );

      showToast("Folder created successfully", "success");

      setIsAdding(false);
      setNewType("");

      fetchTypes(); // reload folders
    } catch (err) {
      showToast("Folder creation failed", "error");
    } finally {
      setLoader(false);
    }
  };

  // =====================================================
  // 🔹 NAVIGATE TO FOLDER
  // =====================================================
  const handleFolderClick = (folder) => {
    // safer navigation using name
    navigate(`/doc?type=${folder.folder_type}`);

    // if later you want id:
    // navigate(`/doc/${folder.id}`)
  };

  return (
    <SideNavLayout>
      <div className="p-8">
        <h1 className="text-2xl font-bold text-start text-gray-800 mb-6">
          Manuals Dashboard
        </h1>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">

          {/* ================= ADD CARD ================= */}
          <div
            onClick={() => setIsAdding(true)}
            className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-500 hover:bg-blue-50 cursor-pointer"
          >
            <svg
              className="w-16 h-16 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            <span className="mt-2 text-sm font-medium text-gray-600">
              Add Category
            </span>
          </div>

          {/* ================= FOLDER CARDS ================= */}
        {types.map((folder) => (
 <div
  key={folder.id}
  onClick={() => handleFolderClick(folder)}
  className="relative flex flex-col items-center justify-center p-6 bg-white border border-gray-200 rounded-lg hover:shadow-lg cursor-pointer transition group"
>
  {/* DELETE ICON — ONLY ON HOVER */}
  <FontAwesomeIcon
    icon={faTrash}
    onClick={(e) => openDeleteModal(folder, e)}
    className="
      absolute bottom-3 right-3
      text-red-500
      opacity-0
      group-hover:opacity-100
      transition
      duration-200
      hover:scale-110
    "
  />

  <svg
    className="w-16 h-16 text-yellow-500"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
  </svg>

  <span className="mt-2 text-sm font-medium text-gray-700">
    {folder.folder_type}
  </span>
</div>

))}

        </div>

        {/* ================= ADD MODAL ================= */}
        <AddTypeModal
          isOpen={isAdding}
          onClose={() => {
            setIsAdding(false);
            setNewType("");
          }}
          newType={newType}
          setNewType={setNewType}
          onAdd={handleAddType}
        />
      </div>

      {/* ================= LOADER ================= */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
<DeleteConfirmModal
  isOpen={deleteModal}
  onClose={() => setDeleteModal(false)}
  onConfirm={confirmDelete}
/>

      {/* ================= TOAST ================= */}
      <ToastMessage
        message={alertMessage}
        severity={severity}
        open={open}
        handleClose={handleCloseToast}
      />
    </SideNavLayout>
  );
};

export default ManualWrapper;
